import { defineStore } from 'pinia';
import { markRaw } from 'vue';

export const useScheduleStore = defineStore('schedule', {
  state: () => ({
    schedules: [],
    scheduleTemplates: [],
    scheduleTemplatesObj: {},
    scheduleTasksObj: {},
    scheduleUsesDates: false,
    calendars: [],
    commitTitle: '',
    commitMessage: '',
  }),
  getters: {
    getSchedules: (state) => state.schedules,
    getScheduleTemplates: (state) => state.scheduleTemplates,
    getScheduleTasksObj: (state) => state.scheduleTasksObj,
    getScheduleTemplatesObj: (state) => state.scheduleTemplatesObj,
    getScheduleUsesDates: (state) => state.scheduleUsesDates,
    getCalendars: (state) => state.calendars,
    getCommitTitle: (state) => state.commitTitle,
    getCommitMessage: (state) => state.commitMessage,
  },
  actions: {
    setSchedules(schedules) {
      this.schedules = schedules;
    },
    addSchedule(schedule) {
      this.schedules.push(schedule);
    },
    setScheduleTemplates(scheduleTemplates) {
      this.scheduleTemplates = scheduleTemplates;
    },
    setScheduleTasksObj(scheduleTasksObj) {
      // Whole task trees keyed by schedule id; never proxied (see task store).
      this.scheduleTasksObj = markRaw(scheduleTasksObj);
    },
    setScheduleTemplatesObj(scheduleTemplatesObj) {
      this.scheduleTemplatesObj = scheduleTemplatesObj;
    },
    setScheduleUsesDates(scheduleUsesDates) {
      this.scheduleUsesDates = scheduleUsesDates;
    },
    setCalendars(calendars) {
      this.calendars = calendars;
    },
    setCommitTitle(title) {
      this.commitTitle = title;
    },
    setCommitMessage(message) {
      this.commitMessage = message;
    },
    updateCommitTitle(title) {
      this.setCommitTitle(title);
    },
    updateCommitMessage(message) {
      this.setCommitMessage(message);
    },
  },
});
